import Moment from "moment-timezone";

// CSV export headers
export const headers = [
  "id",
  "windowSequenceName",
  "windowNames",
  "status",
  "createdBy",
  "createdAt",
  "modifiedBy",
  "modifiedAt",
];

// CSV export column renames
export const rename = [
  "id",
  "Window Sequence Name",
  "Window Names",
  "Status",
  "Created By",
  "Created At",
  "Modified By",
  "Modified At",
];

/**
 * Transform window sequences data for CSV export
 * @param {Array} windowSequences - Array of window sequence objects
 * @returns {Array} - Flattened array for CSV export
 */
export function transformWindowsForExport(windowSequences) {
  if (!Array.isArray(windowSequences)) return [];

  return windowSequences.map((windowSequence) => {
    const windowNames = windowSequence.windows
      ? windowSequence.windows.map((w) => w.windowName || w.label).join(", ")
      : "";

    return {
      id: windowSequence.id,
      windowSequenceName: windowSequence.windowSequenceName,
      windowNames,
      status: windowSequence.status,
      createdBy: windowSequence.createdBy?.fullName || "",
      createdAt: windowSequence.createdAt
        ? Moment(Moment.utc(windowSequence.createdAt).toDate()).format(
            "DD-MMM-YYYY",
          )
        : "",
      modifiedBy: windowSequence.modifiedBy?.fullName || "",
      modifiedAt: windowSequence.modifiedAt
        ? Moment(Moment.utc(windowSequence.modifiedAt).toDate())
            .tz(Moment.tz.guess())
            .format("DD-MMM-YYYY, h:mm:ss A z")
        : "",
    };
  });
}
